import { unique } from 'remeda'
import { FoldXMeasureId, FoldYMeasureId, MeasureId } from 'src/dataReshape'
import type { AdvancedPipe, Dimension, Dimensions, Encoding, Measure, Measures } from 'src/types'

export const defaultEncodingForRaceScatter: AdvancedPipe = (advancedVSeed) => {
  const { measures = [], dimensions = [] } = advancedVSeed
  const encoding: Encoding = {}
  generateDefaultDimensionEncoding(dimensions, encoding)
  generateDefaultMeasureEncoding(measures, encoding)
  return { ...advancedVSeed, encoding }
}

export const encodingForRaceScatter: AdvancedPipe = (advancedVSeed) => {
  const { measures = [], dimensions = [] } = advancedVSeed

  // exist encoding condition
  const hasDimensionEncoding = dimensions.some((item: Dimension) => item.encoding)
  const hasMeasureEncoding = measures.some((item: Measure) => item.encoding)

  // encoding for modify in place
  const encoding: Encoding = {}

  if (hasDimensionEncoding) {
    generateDimensionEncoding(dimensions, encoding)
  } else {
    generateDefaultDimensionEncoding(dimensions, encoding)
  }

  if (hasMeasureEncoding) {
    generateMeasureEncoding(measures, encoding)
  } else {
    generateDefaultMeasureEncoding(measures, encoding)
  }

  return { ...advancedVSeed, encoding }
}
/**
 * --------------------维度--------------------
 */
const generateDefaultDimensionEncoding = (dimensions: Dimensions, encoding: Encoding) => {
  const dimensionsWithoutMeasureId = dimensions.filter((item) => item.id !== MeasureId)
  const uniqueDimIds = unique(dimensionsWithoutMeasureId.map((d) => d.id))
  encoding.player = uniqueDimIds.slice(0, 1) // 第一个维度用于播放
  encoding.detail = encoding.color
  encoding.tooltip = uniqueDimIds.filter((d: string) => ![MeasureId, FoldYMeasureId, FoldXMeasureId].includes(d)) // 展示指标名称之外的所有维度
  encoding.label = [] // 默认不展示标签
  encoding.row = [] // 默认不进行行透视
  encoding.column = [] // 默认不进行列透视
}
const generateDimensionEncoding = (dimensions: Dimensions, encoding: Encoding) => {
  encoding.player = unique(dimensions.filter((item) => item.encoding === 'player').map((item) => item.id))

  // color
  encoding.color = unique(dimensions.filter((item) => item.encoding === 'color').map((item) => item.id))

  // detail
  encoding.detail = unique(dimensions.filter((item) => item.encoding === 'detail').map((item) => item.id))
  if (encoding.detail!.length === 0) {
    encoding.detail = [MeasureId]
  }
  // tooltip
  encoding.tooltip = unique(dimensions.map((item) => item.id))
  encoding.tooltip = encoding.tooltip!.filter((d) => ![MeasureId, FoldYMeasureId, FoldXMeasureId].includes(d))

  // label
  encoding.label = unique(dimensions.filter((item) => item.encoding === 'label').map((item) => item.id))
  encoding.label = encoding.label!.filter((d) => d !== MeasureId)
}

/**
 * --------------------指标--------------------
 */
const generateDefaultMeasureEncoding = (measures: Measures, encoding: Encoding) => {
  encoding.y = unique(
    measures
      .filter((item) => item.encoding === 'xAxis' || item.encoding === 'yAxis' || !item.encoding)
      .map((item) => item.id),
  )
}
const generateMeasureEncoding = (measures: Measures, encoding: Encoding) => {
  encoding.y = unique(
    measures
      .filter((item) => item.encoding === 'xAxis' || item.encoding === 'yAxis' || !item.encoding)
      .map((item) => item.id),
  )
  const color = unique(measures.filter((item) => item.encoding === 'color').map((item) => item.id))
  if (color.length > 0) {
    encoding.color = [color[0]]
  }

  // size
  encoding.size = unique(measures.filter((item) => item.encoding === 'size').map((item) => item.id))

  // label
  const label = unique(measures.filter((item) => item.encoding === 'label').map((item) => item.id))
  encoding.label = unique([...(encoding.label || []), ...label])

  // tooltip
  const tooltip = unique(measures.filter((item) => item.encoding === 'tooltip').map((item) => item.id))
  encoding.tooltip = unique([...(encoding.tooltip || []), ...label, ...tooltip, ...color, ...encoding.size!])
}
